import { render, staticRenderFns } from "./ArchiveTable.vue?vue&type=template&id=42255e24&scoped=true"
import script from "./ArchiveTable.vue?vue&type=script&lang=js"
export * from "./ArchiveTable.vue?vue&type=script&lang=js"
import style0 from "./ArchiveTable.vue?vue&type=style&index=0&id=42255e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42255e24",
  null
  
)

export default component.exports